import { Component, ElementRef, Input, OnInit, ViewChild, inject } from '@angular/core';
import { SnackBarService } from '../../services/snack-bar.service';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-snackbar',
    templateUrl: './snackbar.component.html',
    styleUrls: ['./snackbar.component.scss'],
    imports: [NgClass]
})
export class SnackbarComponent implements OnInit {
  private snackBarService = inject(SnackBarService);

  @Input() message = 'Mensaje';
  @Input() type = 'info';
  @Input() animation = 'short';
  @Input() id: string | undefined;
  iconName!: string;
  visible = false;
  timer: any;
  styles = '';

  @ViewChild('snackbar')
  snackBar!: ElementRef;

  ngOnInit(): void {
    this.iconName = this.getIcon(this.type);

    this.snackBarService.add(this);
  }

  getIcon(type: string) {
    let iconName;

    switch (type) {
      case 'warning':
        iconName = 'notification-warning';
        break;
      case 'success':
        iconName = 'notification-success';
      case 'info':
        iconName = 'notification-information-circle';
      default:
        iconName = 'notification-information-circle';
        break;
    }

    return iconName;
  }

  show(message: string, type: string = 'info', animation: string = 'long') {
    this.animation = '';
    this.visible = false;

    setTimeout(() => {
      this.message = message;
      this.type = type;
      this.animation = animation;
      this.visible = true;

      const position = this.snackBarService.getPosition();

      let positionAnimation = 0;

      if (position > 0) {
        positionAnimation = position + 12;
      } else {
        positionAnimation = 12;
      }

      let positionInitial = -12;
      const id = setInterval(() => {
        positionInitial++;
        if (positionInitial === positionAnimation) {
          clearInterval(id);
        }
        this.styles = `top:${positionInitial}px`;
      }, 1);

      if (this.timer) {
        clearTimeout(this.timer);
      }
    }, 200);

    this.timer = setTimeout(() => {
      this.animation = '';
      console.log('clear snackbar');
      this.visible = false;
    }, 8000);
  }
}
